import {
  Flex,
  IconButton,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Avatar,
  useColorModeValue,
} from '@chakra-ui/react';
import { MdMenu, MdLogout, MdPerson } from 'react-icons/md';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NavbarProps {
  onOpen: () => void;
}

export default function Navbar({ onOpen }: NavbarProps) {
  const { t } = useTranslation('common');
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'navy.800');
  const borderColor = useColorModeValue('gray.200', 'navy.700');

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/auth/signin');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <Flex
      as="nav"
      position="fixed"
      top={0}
      right={0}
      left={{ base: 0, md: '280px' }}
      h="20"
      bg={bgColor}
      borderBottom="1px"
      borderColor={borderColor}
      alignItems="center"
      justifyContent="space-between"
      px={6}
      zIndex={10}
    >
      {/* Mobile menu button */}
      <IconButton
        display={{ base: 'flex', md: 'none' }}
        onClick={onOpen}
        variant="ghost"
        icon={<MdMenu />}
        aria-label="Open menu"
        size="lg"
      />

      <Text fontSize="lg" fontWeight="600" display={{ base: 'none', md: 'block' }}>
        {t('greeting.welcomeBack')}
      </Text>

      {/* User menu */}
      <Menu>
        <MenuButton>
          <Avatar
            size="sm"
            name={user?.email || 'User'}
            bg="brand.500"
            color="white"
            cursor="pointer"
          />
        </MenuButton>
        <MenuList>
          <MenuItem icon={<MdPerson />} isDisabled>
            {user?.email}
          </MenuItem>
          <MenuItem icon={<MdLogout />} onClick={handleSignOut}>
            {t('nav.signOut')}
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  );
}
